import { Tabs, Tab } from "@mui/material";
import { useRouter } from "next/router";
import * as T from "common/src/bindings/Translation2";

export default function DropTablesNav({ route }: { route: string }) {
  const router = useRouter();
  return (
    <div className="px-3 pt-2 pb-0 mb-3 sticky top-[48px] md:top-[92px] bg-bg0 z-20">
      <Tabs
        value={route}
        variant="scrollable"
        onChange={(_, t) => {
          switch (t) {
            case "CrystalGambit":
              router.push("/info/set-15/tables/crystal-gambit");
              break;
            case "NineLives":
              router.push("/info/set-15/tables/nine-lives");
              break;
            case "Gloryseeker":
              router.push("/info/set-15/tables/gloryseeker");
              break;
            case "RogueCaptain":
              router.push("/info/set-15/tables/rogue-captain");
              break;
            case "SoulFighter":
              router.push("/info/set-15/tables/soulfighter");
              break;
            case "TreasureHunt":
              router.push("/info/set-15/tables/treasure-hunt");
              break;
            // case "Double Up":
            //   router.push("/info/set-15/tables/double-up");
            //   break;
            case "Augments":
              router.push("/info/set-15/tables/augments");
              break;
            case "LootOrbs":
              router.push("/info/set-15/tables/loot-orbs");
              break;
            case "Reroll":
              router.push("/info/set-15/tables/reroll");
              break;
            case "Golden Egg":
              router.push("/info/set-15/tables/golden-egg");
              break;
            case "Thief's Gloves":
              router.push("/info/set-15/tables/thiefs-gloves");
              break;
            case "Loot Subscription":
              router.push("/info/set-15/tables/loot-subscription");
              break;
            case "Call to Chaos":
              router.push("/info/set-15/tables/call-to-chaos");
              break;
            case "Magic Roll":
              router.push("/info/set-15/tables/magic-roll");
              break;
            case "Exalted Adventure":
              router.push("/info/set-15/tables/exalted-adventure");
              break;
            case "Expected Unexpectedness":
              router.push("/info/set-15/tables/expected-unexpectedness");
              break;
          }
        }}
      >
        <Tab label={T.common("Augments")} value="Augments" />
        <Tab label={T.augments("11Calltochaos")} value="Call to Chaos" />
        <Tab label={T.traits("TFT15_GemForce")} value="CrystalGambit" />
        <Tab
          label={T.augments("AnExaltedAdventure")}
          value="Exalted Adventure"
        />
        <Tab
          label={T.augments("ExpectedUnexpectedness")}
          value="Expected Unexpectedness"
        />
        {/* <Tab label={T.augments("Gloryseeker")} value="Gloryseeker" /> */}
        <Tab label={T.common("Golden Egg")} value="Golden Egg" />
        <Tab label={T.common("Loot Orbs")} value="LootOrbs" />
        <Tab
          label={T.common("TFT_Portals_Unique_LootSubscription")}
          value="Loot Subscription"
        />
        <Tab label={T.augments("MagicRoll")} value="Magic Roll" />
        <Tab label={T.augments("Nine Lives")} value="NineLives" />
        <Tab label={T.common("Reroll")} value="Reroll" />
        <Tab label={T.traits("TFT15_Captain")} value="RogueCaptain" />
        <Tab label={T.traits("TFT15_SoulFighter")} value="SoulFighter" />
        <Tab label={T.items("ThiefsGloves")} value="Thief's Gloves" />
        <Tab label={T.augments("TreasureHunt")} value="TreasureHunt" />
      </Tabs>
    </div>
  );
}
